import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useEffect } from 'react';
import { useTaktId, createStormTaktId } from '@amzn/storm-ui';
import { F as FormLayoutCloseButton, a as FormLayoutCloseIcon } from './FormLayoutCloseButton-C-L-Y72E.js';
import { H as Header, g as HeaderText } from './FormLayout.styles-BzYy_4z2.js';
import { u as useFormStage } from './hooks/useStage-C5gC2haD.js';
import { t as times } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-DpE3j47V.js';
import { n as noop } from '../../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const FormLayoutHeader = ({
  closeButtonLabel = 'Close feedback',
  isMobile,
  onClose = noop,
  renderHeader = 'Share your feedback with us'
}) => {
  const {
    stage
  } = useFormStage();
  const closeButtonRef = useRef(null);
  const {
    getDataTaktAttributes: getCloseButtonDataTaktAttributes
  } = useTaktId({
    fallbackId: createStormTaktId('close-button')
  });
  useEffect(() => {
    if (!isMobile) {
      var _closeButtonRef$curre, _closeButtonRef$curre2;
      (_closeButtonRef$curre = closeButtonRef.current) === null || _closeButtonRef$curre === void 0 || (_closeButtonRef$curre2 = _closeButtonRef$curre.focus) === null || _closeButtonRef$curre2 === void 0 || _closeButtonRef$curre2.call(_closeButtonRef$curre);
    }
  }, [isMobile, stage]);
  return /*#__PURE__*/React__default.createElement(Header, {
    $isMobileSubmittedStage: isMobile && stage === 'submitted'
  }, /*#__PURE__*/React__default.createElement(HeaderText, {
    $isMobileSubmittedStage: isMobile && stage === 'submitted'
  }, typeof renderHeader === 'function' ? renderHeader() : renderHeader), !isMobile && /*#__PURE__*/React__default.createElement(FormLayoutCloseButton, _extends({
    closeButtonLabel: closeButtonLabel,
    onClick: onClose,
    ref: closeButtonRef
  }, getCloseButtonDataTaktAttributes()), /*#__PURE__*/React__default.createElement(FormLayoutCloseIcon, {
    type: times
  })));
};

export { FormLayoutHeader as F };
//# sourceMappingURL=FormLayoutHeader-CgQx9ByR.js.map
